import type { FC } from "react";
import React from "react";

import cn from "classnames";

import { getTestId } from "../../../../fabrics/createTestId";
import { ButtonCircle } from "../../../ButtonCircle";

import type { HeaderDefaultRightButtonCircleProps } from "./types";

import classes from "./HeaderRightButtonCircle.styl";

const RIGHT_BUTTON_CIRCLE_TEST_ID = getTestId("header-right-button-circle");

/**
 * Компонент используется для HeaderSchevron / HeaderClose
 * -> с превентивной установкой ButtonCircle в качестве правого аддона.
 */
export const HeaderDefaultRightButtonCircle: FC<
    HeaderDefaultRightButtonCircleProps
> = (props) => {
    const {
        "data-tsid": tsid = RIGHT_BUTTON_CIRCLE_TEST_ID,
        view,
        icon,
        ...restProps
    } = props;

    const customColorStylesClassName = cn(
        classes["custom-colors"],
        classes[`__view-${view!}`],
    );

    return (
        <ButtonCircle
            {...restProps}
            size="28"
            view="custom"
            data-tsid={tsid}
            customColorsStyles={customColorStylesClassName}
        >
            <ButtonCircle.Icon icon={icon} />
        </ButtonCircle>
    );
};

export default HeaderDefaultRightButtonCircle;
